export default __webpack_public_path__ + "locales/sl/DeleteProfileEverDialog.json?hash=ac71fe86c3e82de3c956876977d63b07";